import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import getDefaultMyTasksViews from "../../../../views/my-tasks/actions/get-default-views";

const debug = false
// const debug = "UserSettingsViewsMyTasks"

export default class UserSettingsViewsMyTasks extends ServerSettings {

    public addedViews       : JSONArray

    constructor(config: any) {

        const fieldsConfig = {
            'addedViews': {
                type            : ServerSettingsFieldType.VALUE,
                defaultValue    : getDefaultMyTasksViews(),
            }
        }

        super(config, fieldsConfig);

        this.addedViews     = this.initValue('addedViews')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'addedViews')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
